import { rateItems, factorItems } from "@/mocks/gossipGuide";

export default function RatesSection() {
  return (
    <section id="rates" className="mx-auto w-full max-w-7xl scroll-mt-20 px-4 py-16 md:px-6 md:py-20">
      <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
        <div>
          <p className="text-sm font-semibold uppercase tracking-wide text-accent-600">稿费单价</p>
          <h2 className="mt-2 text-3xl text-foreground-950 md:text-4xl">你的瓜，值多少稿费</h2>
          <p className="mt-3 max-w-2xl text-foreground-600">
            吃瓜投稿的收益单价没有一刀切，下面按常见内容形态给出参考区间，帮你投稿前先心里有数。
          </p>
        </div>
      </div>

      <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {rateItems.map((item) => (
          <article
            key={item.type}
            className="group flex flex-col rounded-2xl bg-background-50 p-6 ring-1 ring-background-200 transition-transform duration-300 hover:-translate-y-1 hover:shadow-card"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-100 text-2xl text-primary-600">
              <i className={item.icon} aria-hidden="true"></i>
            </span>
            <h3 className="mt-4 text-xl font-semibold text-foreground-950">{item.type}</h3>
            <p className="mt-1 text-sm text-foreground-600">{item.unit}</p>
            <p className="mt-4 font-display text-4xl text-primary-500">
              {item.range}
              <span className="text-xl text-foreground-400"> 元</span>
            </p>
            <p className="mt-2 text-sm font-semibold text-foreground-800">{item.base} 元起</p>
            <p className="mt-4 border-t border-background-200 pt-4 text-sm leading-relaxed text-foreground-600">
              {item.note}
            </p>
          </article>
        ))}
      </div>

      <div className="mt-14">
        <div className="flex items-center gap-2">
          <span className="h-6 w-1.5 rounded-full bg-secondary-500" aria-hidden="true"></span>
          <h3 className="text-2xl text-foreground-950 md:text-3xl">哪些因素让单价上涨</h3>
        </div>
        <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {factorItems.map((f) => (
            <div
              key={f.title}
              className="flex gap-4 rounded-2xl bg-secondary-100/70 p-5 ring-1 ring-secondary-200/70"
            >
              <span className="mt-0.5 flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-secondary-500 text-xl text-background-50">
                <i className={f.icon} aria-hidden="true"></i>
              </span>
              <div>
                <h4 className="font-semibold text-foreground-950">{f.title}</h4>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{f.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}